import React from "react";
import {
  List,
  Datagrid,
  TextField, 
  DateField,
  EditButton
} from "admin-on-rest";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { SlugLinkButton } from '../components/button';
import { ProductCreate as create, ProductEdit as edit } from "./Create";
import { ProductFilter, ProductsActions } from './defaultValues';
import "./index.css";

export const ProductCreate = create;
export const ProductEdit = edit;


export const ProductsList = props => (
  <List
    {...props}
    actions={<ProductsActions />}
    title={<IconTitle icon="products" title={"resources.products.title"} />}
    sort={{ field: "created_at", order: "DESC" }}
    filters={<ProductFilter />}
    perPage={10}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField label="resources.products.fieldList.name" source="name" />
      <TextField label="resources.products.fieldList.slug" source="slug" />
      <DateField
        label="resources.products.fieldList.create_at"
        source="created_at"
      />

      <EditButton label="" style={{ textAlign: "right" }} />
      <SlugLinkButton label="" url="products" />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/products/index.js